export const NOVU_APPLICATION_ID = import.meta.env.VITE_NOVU_APPLICATION_ID
export const NOVU_API_URL = import.meta.env.VITE_NOVU_API_URL
export const NOVU_WS_URL = import.meta.env.VITE_NOVU_WS_URL
